import { http } from './config'
import authHeader from './auth-header'

export default {
  abertos_por_categoria: (entityId) => {
    return http.get(`/api/glpi/abertos-por-categoria/${entityId}`)
  },

  solucionados_fechados: (entityId) => {
    return http.get(`/api/glpi/solucionados-fechados/${entityId}`)
  },

  tempo_resolucao: (entityId) => {
    return http.get(`/api/glpi/tempo-resolucao/${entityId}`)
  },

  listar_entidades: () => {
    return http.get('/api/glpi/entidades', {
      headers: authHeader()
    })
  },

  listar_categorias: (entityId) => {
    return http.get(`/api/glpi/categorias?entityId=${entityId}`, {
      headers: authHeader()
    })
  },

  listar_usuarios: () => {
    return http.get('/api/glpi/usuarios', {
      headers: authHeader()
    })
  },

  listar_localizacoes: () => {
    return http.get('/api/glpi/localizacoes', {
      headers: authHeader()
    })
  },

  performance_setor: (filtros) => {
    const params = typeof filtros === 'object' && !Array.isArray(filtros) 
      ? filtros 
      : { entityId: Array.isArray(filtros) ? filtros[0] : filtros }

    return http.post('/api/glpi/performance-setor', null, {
      params: params,
      headers: authHeader()
    })
  },

  ranking_localizacao: (filtros) => {
    const params = typeof filtros === 'object' && !Array.isArray(filtros) 
      ? filtros 
      : { entityId: Array.isArray(filtros) ? filtros[0] : filtros }

    return http.post('/api/glpi/ranking-localizacao', null, {
      params: params,
      headers: authHeader()
    })
  },

  listar_chamados: (filtros) => {
    const params = typeof filtros === 'object' && !Array.isArray(filtros) 
      ? filtros 
      : { entityId: Array.isArray(filtros) ? filtros[0] : filtros }

    return http.post('/api/glpi/listar-chamados', null, {
      params: params,
      headers: authHeader()
    })
  }
}